<template>
    <div class="panel">
        <img class="copd-text" src="@/assets/images/copdText.png" alt="iDAvatars - copd diary">
    </div>
</template>

<script>
    export default {
        name: 'Intro_panel'
    }
</script>
<style scoped lang="stylus">
.panel
    text-align: center
    padding-top: 7em
</style>